import axios from 'axios';
import store from "../store";
const PREFIJO="/api/PrdcBnfCnsl/";

export default {
    beneficios(totalMantenimientos, numeroMantenimientos, agenciaId, listaOperaciones, nombreMarca) {
        const dto={
            ndt1:agenciaId,
            ndt4:totalMantenimientos,
            ndt5:numeroMantenimientos,
            dt1: listaOperaciones,
            dt2: nombreMarca
        };
        return axios.post(`${PREFIJO}VmPrdcBnfCnsl`,dto);
    }
};
